<template>
  <ApplicationLayout
    :user="user"
    :options="options"
    :version="version"
    :links="links"
    :showActionItems="true"
  >
    <!-- Set System bar content if enabled-->
    <template #systembar></template>

    <!-- Set Appbar title-->
    <template #title>
      <v-toolbar-title class="font-weight-bold d-flex">
        IFRS9 - {{ getTitle() }}
      </v-toolbar-title>
      <v-icon small style="margin-top: -20px">mdi-apps</v-icon>
    </template>

    <!-- Use to add addition items to Appbar -->
    <template #toolbar>
      <ReportIssueButton />
    </template>

    <!-- Use change Navbar header content-->
    <template #navheader></template>

    <!-- Use display content-->
    <template #content>
      <router-view :key="$route.fullPath"/>
    </template>
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout
  from '@/modules/shared/components/core/layouts/ApplicationLayout.vue';
import IFRS9Mixin from '@/modules/ifrs9/common/ifrs9.mixin'
import ReportIssueButton from '@/modules/shared/components/core/ReportIssueButton.vue';

const layoutOptions = {
  showSystemBar: false,
  showSearchBar: false,
  showUserOptions: true,
  showMenuToggle: true,
  appBarColor: '#fafbfc',
  miniDrawerColor: '',
  miniDrawerIconsColor: 'white',
  leftDrawerColor: 'white',
  leftDrawerIconsColor: ''
};

export default {
  components: { ApplicationLayout, ReportIssueButton },
  mixins: [IFRS9Mixin],
  data: () => ({
    options: layoutOptions,
    links: [
      {
        title: 'Dashboard',
        icon: 'mdi-chart-line',
        to: '/ifrs9/dashboard'
      },
      {
        title: 'Reports',
        icon: 'mdi-file-document',
        to: '/ifrs9/downloads'
      }
    ]
  }),

  mounted() {
    if(this.checkAuth('View File Uploads')) {
      this.links.push({
        title: 'Upload Center',
        icon: 'mdi-upload',
        to: '/ifrs9/uploads'
      });
    }

    if(this.checkAuth('View General Settings')) {
      this.links.push(
        {
          heading: 'Settings',
          icon: 'mdi-cogs',
          group: 'company',
          items: [{
            title: 'General',
            to: '/ifrs9/general-settings'
          }]
        });

      if(this.checkAuth('View IFRS9 Settings')) {
        this.links[this.links.length - 1].items.push({
          title: 'IFRS9',
          to: '/ifrs9/ifrs9-settings'
        });
      }
    }
  },

  methods: {
    getTitle() {
      return this.$route.name;
    },
  }

};
</script>